import { render, staticRenderFns } from "./modalViewTransactionDetails.vue?vue&type=template&id=05f6c0bb&"
import script from "./modalViewTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./modalViewTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports